/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface DeletionTrackingEntryDTO
 */
export interface DeletionTrackingEntryDTO  {
    /**
     * 
     * @type {number}
     * @memberof DeletionTrackingEntryDTO
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof DeletionTrackingEntryDTO
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof DeletionTrackingEntryDTO
     */
    entityType?: string;
    /**
     * 
     * @type {Date}
     * @memberof DeletionTrackingEntryDTO
     */
    deletedTimestamp?: Date;
}

/**
 * Check if a given object implements the DeletionTrackingEntryDTO interface.
 */
export function instanceOfDeletionTrackingEntryDTO(value: object): value is DeletionTrackingEntryDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DeletionTrackingEntryDTOFromJSON(json: any): DeletionTrackingEntryDTO {
    return DeletionTrackingEntryDTOFromJSONTyped(json, false);
}

export function DeletionTrackingEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletionTrackingEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'],
                  'entityId': json['entityId'] == null ? undefined : json['entityId'],
                  'entityType': json['entityType'] == null ? undefined : json['entityType'],
                'deletedTimestamp': json['deletedTimestamp'] == null ? undefined : (new Date(json['deletedTimestamp'])),
    };
}

export function DeletionTrackingEntryDTOToJSON(json: any): DeletionTrackingEntryDTO {
    return DeletionTrackingEntryDTOToJSONTyped(json, false);
}

export function DeletionTrackingEntryDTOToJSONTyped(value?: DeletionTrackingEntryDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'entityId': value['entityId'],
        'entityType': value['entityType'],
        'deletedTimestamp': value['deletedTimestamp']?.toISOString(),
    };
}


